export default "__VITE_ASSET__4eUWzDZs__"